export function isInAppWebView() {
  if (typeof navigator === "undefined") return false;

  const ua = navigator.userAgent.toLowerCase();
  // pcp , android , ios 쪽에서 userAgent 에 삽입해준 문자열
  return (
    ua.includes("wv") ||
    ua.includes("android-webview") ||
    ua.includes("ios-webview")
  );
}
